(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flash-sale-product-grid"] && !Shopify.designMode) return;
  try {
    
  class FlashSaleCountdown {
    constructor(container) {
      this.container = container;
      if (!this.container) return;

      this.timerEl = this.container.querySelector('[data-countdown-date]');
      if (!this.timerEl) return;

      this.endDateString = this.timerEl.dataset.countdownDate;
      this.expiredEl = this.container.querySelector('[data-expired-message]');
      this.daysEl = this.timerEl.querySelector('[data-days]');
      this.hoursEl = this.timerEl.querySelector('[data-hours]');
      this.minutesEl = this.timerEl.querySelector('[data-minutes]');
      this.secondsEl = this.timerEl.querySelector('[data-seconds]');
      
      this.interval = null;
      this.init();
    }

    init() {
      if (!this.endDateString) return;

      const endDate = new Date(this.endDateString).getTime();
      if (isNaN(endDate)) {
        console.error('Invalid countdown date format:', this.endDateString);
        return;
      }

      this.updateTimer(endDate);
      this.interval = setInterval(() => this.updateTimer(endDate), 1000);
    }

    stop() {
      clearInterval(this.interval);
    }

    updateTimer(endDate) {
      const now = new Date().getTime();
      const distance = endDate - now;

      if (distance < 0) {
        this.stop();
        this.timerEl.style.display = 'none';
        if (this.expiredEl) this.expiredEl.style.display = 'block';
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      const format = (num) => String(num).padStart(2, '0');

      if (this.daysEl) this.daysEl.textContent = format(days);
      if (this.hoursEl) this.hoursEl.textContent = format(hours);
      if (this.minutesEl) this.minutesEl.textContent = format(minutes);
      if (this.secondsEl) this.secondsEl.textContent = format(seconds);
    }
  }

  function initSection(sectionEl) {
    if (!sectionEl) return;
    const sectionId = sectionEl.dataset.sectionId;
    const countdownInstanceKey = `flashCountdown_${sectionId}`;

    // Clear old instance if it exists
    if (window[countdownInstanceKey]) {
      window[countdownInstanceKey].stop();
    }
    
    // Create new instance
    window[countdownInstanceKey] = new FlashSaleCountdown(sectionEl);
  }

  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.flash-sale-grid-section');
    sections.forEach(section => initSection(section));
  });

  document.addEventListener('shopify:section:load', (event) => {
    const sectionEl = event.target.querySelector('.flash-sale-grid-section');
    initSection(sectionEl);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const sectionEl = event.target.querySelector('.flash-sale-grid-section');
    if (sectionEl) {
      const sectionId = sectionEl.dataset.sectionId;
      const countdownInstanceKey = `flashCountdown_${sectionId}`;
      if (window[countdownInstanceKey]) {
        window[countdownInstanceKey].stop();
        delete window[countdownInstanceKey];
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flash-sale-slider"] && !Shopify.designMode) return;
  try {
    
  class FlashSaleSlider {
    constructor(container) {
      this.container = container;
      if (!this.container) return;

      this.wrapper = this.container.querySelector('.flash-sale-slider-wrapper');
      this.slides = this.container.querySelectorAll('.flash-sale-slide');
      this.dots = this.container.querySelectorAll('.flash-sale-slider__dot');
      this.prevButton = this.container.querySelector('[data-nav-prev]');
      this.nextButton = this.container.querySelector('[data-nav-next]');
      this.countdownTimers = this.container.querySelectorAll('[data-countdown-date]');

      this.slideCount = this.slides.length;
      if (this.slideCount === 0) return;

      this.currentIndex = 0;
      this.autoplay = this.container.dataset.autoplay === 'true';
      this.autoplaySpeed = parseInt(this.container.dataset.autoplaySpeed, 10);
      this.autoplayTimer = null;

      this.init();
    }

    init() {
      this.bindEvents();
      this.initCountdownTimers();
      if (this.autoplay && this.slideCount > 1) {
        this.startAutoplay();
      }
    }

    bindEvents() {
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.changeSlide(-1));
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.changeSlide(1));
      }
      this.dots.forEach(dot => {
        dot.addEventListener('click', (e) => this.goToSlide(parseInt(e.currentTarget.dataset.slideTo, 10)));
      });

      // Pause autoplay on hover
      this.container.addEventListener('mouseenter', () => this.stopAutoplay());
      this.container.addEventListener('mouseleave', () => this.startAutoplay());
    }

    changeSlide(direction) {
      let newIndex = (this.currentIndex + direction) % this.slideCount;
      if (newIndex < 0) {
        newIndex = this.slideCount - 1;
      }
      this.goToSlide(newIndex);
    }

    goToSlide(index) {
      if (index === this.currentIndex) return;

      this.slides[this.currentIndex].classList.remove('is-active');
      this.dots[this.currentIndex]?.classList.remove('is-active');

      this.currentIndex = index;

      this.slides[this.currentIndex].classList.add('is-active');
      this.dots[this.currentIndex]?.classList.add('is-active');

      this.resetAutoplay();
    }

    startAutoplay() {
      if (!this.autoplay || this.slideCount <= 1) return;
      this.stopAutoplay(); // Clear existing timer
      this.autoplayTimer = setInterval(() => {
        this.changeSlide(1);
      }, this.autoplaySpeed);
    }

    stopAutoplay() {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }

    resetAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }

    initCountdownTimers() {
      this.countdownTimers.forEach(timerContainer => {
        const endDateString = timerContainer.dataset.countdownDate;
        if (!endDateString) return;

        // Try to parse the date. Shopify setting might be ISO 8601
        const endDate = new Date(endDateString).getTime();

        if (isNaN(endDate)) {
          console.error('Invalid countdown date format:', endDateString);
          return;
        }

        const timerWrapper = timerContainer.closest('.flash-sale-countdown');
        const daysEl = timerContainer.querySelector('[data-days]');
        const hoursEl = timerContainer.querySelector('[data-hours]');
        const minutesEl = timerContainer.querySelector('[data-minutes]');
        const secondsEl = timerContainer.querySelector('[data-seconds]');
        const expiredEl = timerWrapper.querySelector('[data-expired-message]');

        const updateTimer = () => {
          const now = new Date().getTime();
          const distance = endDate - now;

          if (distance < 0) {
            clearInterval(interval);
            timerContainer.style.display = 'none';
            if (expiredEl) expiredEl.style.display = 'block';
            return;
          }

          const days = Math.floor(distance / (1000 * 60 * 60 * 24));
          const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((distance % (1000 * 60)) / 1000);

          // Add leading zeros
          const format = (num) => String(num).padStart(2, '0');

          if (daysEl) daysEl.textContent = format(days);
          if (hoursEl) hoursEl.textContent = format(hours);
          if (minutesEl) minutesEl.textContent = format(minutes);
          if (secondsEl) secondsEl.textContent = format(seconds);
        };

        const interval = setInterval(updateTimer, 1000);
        updateTimer(); // Run once immediately
      });
    }
  }

  // Handles section loading and re-loading in the theme editor
  function initSection(sectionEl) {
    if (!sectionEl) return;
    const sectionId = sectionEl.dataset.sectionId;
    const sliderInstanceKey = `flashSlider_${sectionId}`;

    // Avoid re-initializing if instance already exists
    if (window[sliderInstanceKey]) {
      // If it exists, maybe just re-init timers
      window[sliderInstanceKey].initCountdownTimers();
    } else {
      window[sliderInstanceKey] = new FlashSaleSlider(sectionEl);
    }
  }

  // Initial load
  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.flash-sale-slider-section');
    sections.forEach(section => initSection(section));
  });

  // Shopify theme editor events
  document.addEventListener('shopify:section:load', (event) => {
    const sectionEl = event.target.querySelector('.flash-sale-slider-section');
    initSection(sectionEl);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const sectionEl = event.target.querySelector('.flash-sale-slider-section');
    if (sectionEl) {
      const sectionId = sectionEl.dataset.sectionId;
      const sliderInstanceKey = `flashSlider_${sectionId}`;
      if (window[sliderInstanceKey]) {
        window[sliderInstanceKey].stopAutoplay();
        delete window[sliderInstanceKey];
      }
    }
  });

  document.addEventListener('shopify:section:reorder', () => {
    // Re-init all sections on reorder just in case
    const sections = document.querySelectorAll('.flash-sale-slider-section');
    sections.forEach(section => initSection(section));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header = document.querySelector('.header-wrapper');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerIsCover = this.getAttribute('data-sticky-type') === 'cover-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };
      if (this.headerIsCover) {
        this.header.classList.add('shopify-section-header-cover');
        const stickyHeader = document.querySelector('.header-wrapper');
        stickyHeader.classList.add('header-hovered');
        window.addEventListener('scroll', () => {
          let scrollTop =  document.documentElement.scrollTop;
          if (scrollTop > 650) {
            stickyHeader.classList.remove('header-hovered');
          } else {
            stickyHeader.classList.add('header-hovered');
          }
        });
      };
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (this.headerIsCover) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      if (this.headerIsCover) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      if (this.headerIsCover) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  class HeroSlider {
    constructor(sectionId) {
      this.container = document.getElementById(sectionId);
      if (!this.container) return;

      this.slider = this.container.querySelector('.hero-slider-container-inner');
      this.dots = this.container.querySelectorAll('.hero-slider__dot');
      this.slides = this.container.querySelectorAll('.hero-slider__slide');

      this.initDots();
      this.initScrollObserver();
    }

    initDots() {
      if (this.dots.length === 0) return;

      this.dots.forEach(dot => {
        dot.addEventListener('click', () => {
          const slideIndex = parseInt(dot.dataset.slideIndex, 10);
          const targetSlide = this.slides[slideIndex];
          
          if (targetSlide) {
            targetSlide.scrollIntoView({ 
              behavior: 'smooth', 
              inline: 'start',
              block: 'nearest'
            });
          }
        });
      });
    }

    initScrollObserver() {
      if (this.dots.length === 0) return;
      
      const observerOptions = {
        root: this.slider,
        rootMargin: '0px',
        threshold: 0.5
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // Find the index of the intersecting slide
            let slideIndex = -1;
            this.slides.forEach((slide, index) => {
              if (slide === entry.target) {
                slideIndex = index;
              }
            });

            if (slideIndex > -1) {
              this.updateActiveDot(slideIndex);
            }
          }
        });
      }, observerOptions);

      this.slides.forEach(slide => {
        observer.observe(slide);
      });
    }

    updateActiveDot(activeIndex) {
      this.dots.forEach((dot, index) => {
        if (index === activeIndex) {
          dot.classList.add('is-active');
        } else {
          dot.classList.remove('is-active');
        }
      });
    }
  }

  // Initialize a slider for this section
  new HeroSlider('{{ section_id }}');

  // Re-initialize if the section is re-rendered in the theme editor
  document.addEventListener('shopify:section:load', (event) => {
    if (event.detail.sectionId === '{{ section.id }}') {
      new HeroSlider('{{ section_id }}');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-banner"] && !Shopify.designMode) return;
  try {
    
  class PromoPopup {
    constructor(element) {
      this.overlay = element;
      if (!this.overlay) return;

      this.sectionId = this.overlay.dataset.sectionId;
      this.delay = parseInt(this.overlay.dataset.popupDelay, 10);
      this.expiryDays = parseInt(this.overlay.dataset.cookieExpiryDays, 10);
      this.storageKey = `shopify-popup-seen-${this.sectionId}`;

      this.closeButton = this.overlay.querySelector('.promo-popup-close');
      this.ctaButton = this.overlay.querySelector('.promo-popup-button');

      this.init();
    }

    init() {
      if (this.shouldShow()) {
        setTimeout(() => this.show(), this.delay);
      }
      this.addEventListeners();
    }

    shouldShow() {
      const seenTimestamp = localStorage.getItem(this.storageKey);
      if (!seenTimestamp) {
        return true; // Never seen it
      }

      const expiryMs = this.expiryDays * 24 * 60 * 60 * 1000;
      const timeSinceSeen = Date.now() - parseInt(seenTimestamp, 10);

      return timeSinceSeen > expiryMs; // Seen it, but it has expired
    }

    show() {
      this.overlay.classList.add('is-visible');
    }

    hide() {
      this.overlay.classList.remove('is-visible');
      localStorage.setItem(this.storageKey, Date.now().toString());
    }

    addEventListeners() {
      this.closeButton.addEventListener('click', () => this.hide());
      this.overlay.addEventListener('click', (event) => {
        // Only hide if clicking the overlay itself, not the modal content
        if (event.target === this.overlay) {
          this.hide();
        }
      });

      if (this.ctaButton) {
        // Also hide if they click the main button
        this.ctaButton.addEventListener('click', () => this.hide());
      }
    }
  }

  // Wait for the DOM to be ready
  document.addEventListener('DOMContentLoaded', () => {
    const popupElement = document.getElementById('promo-popup-overlay-{{ section.id }}');
    if (popupElement) {
      new PromoPopup(popupElement);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-reels"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const containers = document.querySelectorAll('.shoppable-reels-section');
    
    containers.forEach(section => {
      const track = section.querySelector('.shoppable-reels-track');
      const prevBtn = section.querySelector('.reels-nav-prev');
      const nextBtn = section.querySelector('.reels-nav-next');
      const shareBtns = section.querySelectorAll('.reel-share-btn');
      
      // Carousel logic
      if (track && prevBtn && nextBtn) {
        const getScrollAmount = () => {
          const firstCard = track.querySelector('.shoppable-reel-card');
          return firstCard ? firstCard.offsetWidth + 20 : 300; 
        };

        prevBtn.addEventListener('click', () => {
          track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
        });

        nextBtn.addEventListener('click', () => {
          track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
        });
      }

      // Share Button Logic
      shareBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const urlToShare = btn.getAttribute('data-url');
          const titleToShare = "Check out this product from our store!";

          if (navigator.share) {
            // Opens native mobile share sheet
            navigator.share({
              title: titleToShare,
              url: urlToShare
            }).catch(err => console.log('Error sharing:', err));
          } else {
            // Fallback for desktop: Copy to clipboard
            navigator.clipboard.writeText(urlToShare).then(() => {
              alert('Link copied to clipboard!');
            }).catch(err => {
              console.error('Could not copy text: ', err);
            });
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
